import { Gameplay } from "appworks/model/gameplay/gameplay";
import { CloseRequestPayload } from "appworks/model/gameplay/requests/close-request-payload";
import { InitRequestPayload } from "appworks/model/gameplay/requests/init-request-payload";
import { SlingoRecord } from "slingo/model/records/slingo-record";
import { SlingoRecordBuilder } from "./slingo-record-builder";

export class SlingoCollectRecordBuilder extends SlingoRecordBuilder {
    public id: string = "SlingoCollectRecordBuilder";

    public filter(request: InitRequestPayload, response: any): boolean {
        return request instanceof CloseRequestPayload;
    }

    public build(gameplay: Gameplay, request: any, response: any): SlingoRecord[] {
        const record = super.build(gameplay, request, response)[0];

        if (!record.hasUnplayedBonuses()) {
            record.lastChild = true;
        }

        return [record];
    }
}
